<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
  .map-container{
    height: 450px;
  }
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="lg:w-1/3 sm:w-1/2 w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                        <gridPrincipalItem
                          img="doors"
                          :name="response.alias"
                          :description="$t('Labels.Alias')"
                          :name2="response.serie"
                          :description2="$t('Labels.Serie')"
                        ></gridPrincipalItem>
                        <div class="absolute right-0 top-0">
                            <vs-button  @click="deviceStatistics()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="bar_chart" type="border">
                            </vs-button>
                            <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'"  @click="goToConfig()" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                            </vs-button>
                        </div>
                        <vs-divider/>
                        <valueItem :description="$t('Labels.Status')" :img="doorImage" :value="estado" ></valueItem>

                    </vx-card>
                </div>
                <div class="w-full">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                        <div class="text-center text-3xl">{{$t("Labels.Alerts")}}</div>
                        <vs-divider/>
                        <div class="container-alerts">
                            <doorConfig
                              v-if="showConfig"
                              :val="response.long_alert_timeout || 0"
                              :uuid="uuid"
                              :alertOpen="response.open_alert_enable === 1?true:false"
                              :alertLongOpen="response.long_alert_enable === 1?true:false"
                            />
                        </div>
                    </vx-card>
                </div>

            </div>
            <div class="vx-col lg:w-2/3 sm:w-2/3 w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                    <div class="avatar-info-container">
                        <span class="account-number">
                           {{$t("Labels.DeviceLocation")}}
                        </span>
                        <feather-icon
                            icon="EditIcon"
                            @click="editMap = true"
                            class="float-right cursor-pointer"
                            svgClasses="hover:text-primary"
                            v-if="!editMap && $store.state.AppActiveUser.userRole === 'MA'"/>
                        <feather-icon
                          icon="SaveIcon"
                          @click="saveMap()"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="editMap"/>
                        <div class="map-container" v-if="status_mapa">
                            <l-map :center="center" :zoom="zoom">
                                <l-tile-layer :attribution="attribution" :url="url">
                                </l-tile-layer>
                                <l-marker :draggable="editMap" :lat-lng="marker" ref="position_marker">
                                    <l-icon :icon-anchor="staticAnchor">
                                        <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                    </l-icon>
                                </l-marker>
                            </l-map>
                        </div>
                        <div class="mt-2">
                          <label>{{$t('Labels.References')}}:</label>{{response.location_string  }}
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import doorConfig from '@/components/doorConfig/doorConfig.vue'
import { request } from '@/request.js'
/* global L:true */
const images = ['doors_gray', 'doors_red', 'doors_red']
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    doorConfig,
    valueItem,
    gridPrincipalItem
  },

  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      imagePath: 'images/vendor/leaflet/dist/',
      draggable: true,
      staticAnchor: [12, 27],
      response: [],
      icon_marker: [],
      status_mapa: false,
      uuid: this.$route.params.uuid,
      doorImage: 'doors',
      estado: '',
      editMap: false,
      status: [this.$t('Labels.Close'), this.$t('Labels.Open'), this.$t('Labels.LongOpen')],
      images,
      showConfig: false
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `modelo/doors/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        const [lat, long] = this.response.location.split(',')
        this.marker = L.latLng(lat, long)
        this.center = L.latLng(lat, long)
        this.status_mapa = true
        this.estado = this.status[this.response.status]
        this.doorImage = this.images[this.response.status]
        this.showConfig = true
      })
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `modelo/doors/${this.uuid}`,
        method: 'PUT',
        params: {
          location: `${location.lat},${location.lng}`
        }
      }
      await request(params).then(() => {
        this.editMap = false
      })
    },
    goToConfig () {
      window.location.href = `/doors/config/${this.uuid}`
    },

    deviceStatistics () {
      window.location.href = `/doors/statistics/${this.uuid}`
    }

  },
  sockets: {
    door (payload) {
      if (this.uuid === payload.uuid) {
        this.response.status = payload.status
        this.response.updated_at = payload.updated_at
      }
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
    .vue2leaflet-map >>> .leaflet-shadow-pane {
  display: none !important;
}

>>> .vs-input--label {
  padding: 0;
}
</style>
